import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-holiday-trends';

export default function Example() {
  return (
    <>
      <Head>
        <title>Best Poshmark Holiday Items</title>
        <meta
          name='description'
          content="Holiday trends can get pricey. But to still get in on the action, you're going to need some quick-selling items. We've uncovered the best Poshmark items you can buy now to get on the holiday trend train in this time of year."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-holiday-trends' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-holiday-trends' />
        <meta property='og:title' content='Best Poshmark Holiday Items' />
        <meta
          property='og:description'
          content="Holiday trends can get pricey. But to still get in on the action, you're going to need some quick-selling items. We've uncovered the best Poshmark items you can buy now to get on the holiday trend train in this time of year."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
